module.exports = __webpack_public_path__ + "img/base-map-bright.d3abfd81.png";